import Skeleton from '@mui/material/Skeleton';
import React from 'react';

import LoadingStateWrapper from '@swf/sports/components/LoadingStateWrapper/LoadingStateWrapper';

import styles from './LoadingState.scss';

export const LoadingState: React.FC = () => (
  <LoadingStateWrapper className={styles.container}>
    <Skeleton variant="rectangular" height="35px" width="100%" animation="pulse" />
    <Skeleton variant="rectangular" height="20px" width="75%" animation="pulse" />
    <Skeleton variant="rectangular" height="35px" width="100%" animation="pulse" />
    <Skeleton variant="rectangular" height="20px" width="75%" animation="pulse" />
    <Skeleton variant="rectangular" height="35px" width="100%" animation="pulse" />
    <Skeleton variant="rectangular" height="20px" width="75%" animation="pulse" />
  </LoadingStateWrapper>
);
